import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext } from "./FormContext";

const SettingsContent = ({ formField }) => {
  const { setFormFields } = useFormContext();
  const [values, setValues] = useState(formField.values || {});

  useEffect(() => {
    setFormFields((old) =>
      old.map((item) =>
        item?.type === formField?.type ? { ...item, values } : item
      )
    );
  }, [values]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((old) => ({ ...old, [name]: value }));
  };

  const getInputField = (key, label) => (
    <Box>
      <TextField
        name={key}
        onChange={handleChange}
        label={label}
        size="small"
        fullWidth
        value={values[key] || ""}
      />
    </Box>
  );

  const getSettingsContent = () => {
    let fields = {
      title: {
        component: getInputField("title", "Update title"),
      },
      body: {
        component: getInputField("title", "Update Subtitle"),
      },
      icon: {
        component: getInputField("logoLink", "Update Logo Link"),
      },
      textBox: {
        component: (
          <Box display="flex" flexDirection="column" gap="16px">
            {getInputField("label", "Update label")}
            {getInputField("fieldName", "Update Field Name")}
          </Box>
        ),
        // <Box display="flex" flexDirection="column" gap="16px">
        // {getInputField("label", "Input Label", "Update input label")}

        //   <FormControlLabel
        //     control={
        //       <Switch
        //         checked={values.required}
        //         onChange={(e) =>
        //           handleChange({
        //             target: { name: "required", value: e.target.checked },
        //           })
        //         }
        //       />
        //     }
        //     label="Required"
        //   />
        // </Box>
      },
      buttonText: {
        component: (
          <Box display="flex" flexDirection="column" gap="16px">
            {getInputField("label", "Update button label")}
            {getInputField("deepLink", "Update Deeplink")}
          </Box>
        ),
      },
    };
    return fields[formField.type].component;
  };
  return (
    <Box width="300px" p={8}>
      <Box mb={6}>
        <Typography variant="h6">Update Field Parameters</Typography>
      </Box>
      {getSettingsContent()}
    </Box>
  );
};

export default SettingsContent;
